export default class UtilSequence {

    static async each({ list = [], callback }) {
        
        const accumulator = [];

        for await (const item of list) {
            const response = await callback(item);
            if(response){
                accumulator.push(response);
            }
        }

        return accumulator;
    }

}
